import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../../store';
import { deleteMethod, get, post, put } from '../../../inteceptor';
import moment from 'moment';

const initialState = {
  error: null,
  time: null,
  data: [],
  addData: {},
  sorted: [],
  CookingTypes: [],
};

const slice = createSlice({
  name: 'Cooking',
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = { message: action.payload, time: moment.now().toString() };
    },

    // GET CookingManagement
    getAllCookingTypesSuccess(state, action) {
      state.CookingTypes = action.payload.data;
    },
    // GET CookingManagement
    getCookingsSuccess(state, action) {
      state.data = action.payload.data;
    },

    addOrUpdateCookings(state, action) {
      state.addData = {
        data: action.payload.data,
        time: moment.now().toString(),
      };
    },

    clearAll(state) {
      state.addData = {};
      state.error = {};
    },

    onBackStep(state) {
      state.checkout.activeStep -= 1;
    },

    onNextStep(state) {
      state.checkout.activeStep += 1;
    },

    onGotoStep(state, action) {
      const goToStep = action.payload;
      state.checkout.activeStep = goToStep;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { filterCategories } = slice.actions;

// ----------------------------------------------------------------------

export function getCooking() {
  return async () => {
    try {
      const response = await get(`Cooking`);
      if (response.status) {
        dispatch(slice.actions.getCookingsSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function addCooking(body) {
  return async () => {
    try {
      const response = await post(`Cooking`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateCookings(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function updateCooking(body) {
  return async () => {
    try {
      const response = await put(`Cooking`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateCookings(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function deleteCooking(body) {
  return async () => {
    try {
      const response = await deleteMethod(`Cooking`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateCookings(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
